// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__30sYX","head":"Table_head__1bK7y","col":"Table_col__30EVT"};